// extracted by mini-css-extract-plugin
export default {"parent":"TemplateChooser_parent__l+0KS","visible":"TemplateChooser_visible__RVn-1","hidden":"TemplateChooser_hidden__Vl6Vo","templateChip":"TemplateChooser_templateChip__5I1a0"};